// extracted by mini-css-extract-plugin
export default {"nav_contenedor":"Nav_nav_contenedor__ioiau","titulo":"Nav_titulo__f0GXS","henry":"Nav_henry__2xPKm"};